import React, { PureComponent } from 'react';
import TableGrid from '../../views/TableGrid';
import { Duplicate, Header, HeaderSub, Code, Text, CodeInline } from './../../views/typography';

export default (bottle) => {
  bottle.factory('GroupAddHelp', () => {
    class TermPreview extends PureComponent {
      render() {
        return (
          <section>
            <Header>
              Adding New Spotting Groups
            </Header>
            <HeaderSub>Spotting Group</HeaderSub>
            <Text>
              A Spotting Group is a collection of words or phrases you expect to come up in sound files you want
              transcribed.
            </Text>
            <Text>
              Each Spotting Group has a
              {' '}
              <b>Name</b>
              {' '}
              that you use when you include it for targeting, and a set of
              {' '}
              <b>Keywords</b>
              .
              A keyword can be one word or several words (a phrase). (
              <CodeInline>coupon</CodeInline>
              {' '}
              or
              {' '}
              <CodeInline>direct deposit</CodeInline>
              ).
              You can paste a list of keywords from a CSV file or text editor, one per line as in:
            </Text>
            <div>
              <Code>coupon</Code>
            </div>
            <div>
              <Code>direct deposit</Code>
            </div>
            <div>
              <Code>Wildebeest</Code>
            </div>
            <HeaderSub>Duplicate Words</HeaderSub>
            <Text>
              If you have duplicate keywords these will be highlighted as in
            </Text>
            <TableGrid style={({ width: '100%' })}>
              <thead>
                <tr>
                  <th style={({ minWidth: 80 })}>Keyword</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <Duplicate>coupon</Duplicate>
                </tr>
                <tr>
                  <Duplicate>coupon</Duplicate>
                </tr>
                <tr>
                  <td>direct deposit</td>
                </tr>
                <tr>
                  <td>Wildebeest</td>
                </tr>
                <tr>
                  <td>Blazinski</td>
                </tr>
              </tbody>
            </TableGrid>
            <Header>Correcting/Updating Spotting Groups</Header>
            <Text>
              If you make a mistake and want to correct a list,
              you can use the `Add Spotting Group` button to add a Spotting Group with the same name
              and it will replace the previous entry.
            </Text>
            <Text>
              You can update a Spotting Group list at any time by clicking on the link and updating its keywords,
              or by replacing it using the `Add Spotting Group` button.
            </Text>
            <Header>Deleting Spotting Groups</Header>
            <Text>If you want to delete one or more Spotting Groups click the `Edit` button, check the Spotting Groups
              you want to delete, and click the `Delete Checked` button. This is a <b>Permamant</b> action.
            </Text>
          </section>
        );
      }
    }

    return TermPreview;
  });
};
